<template>
	<div
		:class="[
			'company-address-card-edit',
			localData.isPrimary && 'is-primary'
		]"
		:value="value"
	>
		<Radiobutton
			labelText="Set as primary"
			v-model="localData.isPrimary"
			:isActive="localData.isPrimary"
			name="CompanyPrimaryAddress"
		/>
		<Input
			className="field__input"
			label="Address 1"
			v-model="localData.address1"
		/>
		<Input
			className="field__input"
			label="Address 2"
			v-model="localData.address2"
		/>
		<div class="company-address-card-edit__field-group">
			<Input
				className="field__input"
				label="City"
				v-model="localData.city"
			/>
			<Input
				className="field__input"
				label="County"
				v-model="localData.county"
			/>
		</div>
		<div class="company-address-card-edit__field-group">
			<Input
				className="field__input"
				label="State"
				v-model="localData.state"
			/>
			<Input
				className="field__input"
				label="Zip"
				v-model="localData.zip"
			/>
		</div>
		<div class="company-address-card-edit__field-group">
			<Dropdown
				label="Address Type"
				v-model="localData.type"
				:options="addressTypeOptions"
			/>
			<Button
				v-if="!localData.isPrimary"
				className="btn--icon-only"
				iconClassName="icon-delete-glenn"
				:iconBeforeLabel="true"
				aria-label="Delete"
			/>
		</div>
	</div>
</template>

<script>
import Radiobutton from '@/components/forms/selection-control/radiobutton/radiobutton';
import Input from '@/components/forms/input/input';
import Button from '@/components/forms/button/button';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import _ from 'lodash';

export default {
	name: 'CompanyAddressCardEdit',
	components: { Radiobutton, Input, Button, Dropdown },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			addressTypeOptions: [
				{ text: 'Physical', value: 'P' },
				{ text: 'Billing', value: 'B' },
				{ text: 'Shipping', value: 'S' }
			]
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-address-card-edit {
	@include card;
	width: 365px;
	padding: $padding-md;
	display: grid;
	grid-template-columns: 1fr;
	gap: $gutter-lg;

	&:hover,
	&:active {
		-o-outline: $focus-outline;
		-moz-outline: $focus-outline;
		outline: $focus-outline;
		outline-offset: $focus-offset;
	}

	&__field-group {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: $gutter-xxl;

		.btn--icon-only {
			justify-self: flex-end;
			font-size: 24px;
		}
	}
}
</style>
